import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getCoreTags = api(async function coreTags() {
    return query(
        gql`
            query GetCoreTags {
                coreTags
            }
        `,
        {},
        { returns: "coreTags" }
    )
})
